<script setup>
defineProps({
  title: { type: String, required: true },
  collapsible: { type: Boolean, default: false },
  isOpen: { type: Boolean, default: true },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <section class="px-4 py-3 border-b border-n-weak">
    <button
      v-if="collapsible"
      class="flex items-center justify-between w-full gap-2 group"
      @click="emit('toggle', !isOpen)"
    >
      <span class="text-sm font-medium text-n-slate-12">{{ title }}</span>
      <span
        class="i-lucide-chevron-down size-4 text-n-slate-10 transition-transform duration-200 group-hover:text-n-slate-11"
        :class="{ 'rotate-180': isOpen }"
      />
    </button>
    <h3 v-else class="mb-0 text-sm font-medium text-n-slate-12">
      {{ title }}
    </h3>
    <div v-if="!collapsible || isOpen" class="mt-2.5">
      <slot />
    </div>
  </section>
</template>
